"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedName = void 0;
var _locales = require("./locales");
/**
 * Map of custom attribute localId to locale key
 */
var LOCALE_MAP = {
  '1': {
    defaultName: 'Number',
    localeKey: 'attributes.number'
  },
  '2': {
    defaultName: 'Title',
    localeKey: 'attributes.title'
  },
  number: {
    localeKey: 'attributes.number'
  },
  sheetNumber: {
    localeKey: 'attributes.sheetNumber'
  },
  title: {
    localeKey: 'attributes.title'
  },
  project: {
    localeKey: 'attributes.project'
  },
  originator: {
    localeKey: 'attributes.originator'
  },
  volumeSystem: {
    localeKey: 'attributes.volumeSystem'
  },
  levelLocation: {
    localeKey: 'attributes.levelLocation'
  },
  type: {
    localeKey: 'attributes.type'
  },
  role: {
    localeKey: 'attributes.role'
  },
  status: {
    localeKey: 'attributes.status'
  },
  revision: {
    localeKey: 'attributes.revision'
  },
  classification: {
    localeKey: 'attributes.classification'
  }
};

/**
 * Get the localized name of the custom attribute
 *
 * @param attribute - the custom attribute object
 * @returns Localized name of the custom attribute
 */
var getLocalizedName = exports.getLocalizedName = function getLocalizedName(attribute) {
  var localId = attribute.localId,
    identifier = attribute.identifier,
    name = attribute.name;
  if (localId && LOCALE_MAP[localId]) return (0, _locales.translate)(LOCALE_MAP[localId].localeKey);
  if (identifier) {
    var localeInfo = LOCALE_MAP[identifier];
    if (localeInfo && localeInfo.defaultName === name) return (0, _locales.translate)(localeInfo.localeKey);
  }
  return name;
};